var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99 17.0048L1.62 11.2748L0 12.5348L9 19.5348L18 12.5348L16.37 11.2648L8.99 17.0048ZM9 14.4648L16.36 8.73484L18 7.46484L9 0.464844L0 7.46484L1.63 8.73484L9 14.4648ZM9 2.99484L14.74 7.46484L9 11.9348L3.26 7.46484L9 2.99484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersIcon);
export default __webpack_public_path__ + "static/media/layers-icon.56a717d485bb3383350d7069b4f6c743.svg";
export { ForwardRef as ReactComponent };